import { Box, Typography, Container } from '@mui/material';
import { Link } from 'react-router-dom';

function SupportPage() {
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Container maxWidth="sm" sx={{ flex: 1, py: 4 }}>
        <Link to="/" style={{ color: '#1976d2', fontSize: 14, textDecoration: 'none' }}>
          &larr; Back
        </Link>

        <Typography variant="h4" fontWeight={600} sx={{ mt: 2, mb: 3 }}>
          Support
        </Typography>

        <Typography variant="body1" color="text.secondary">
          For any questions, feature requests, issues, or data requests, please email us at{' '}
          <a href="mailto:support@mythird.place" style={{ color: '#1976d2' }}>
            support@mythird.place
          </a>
          .
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
          You can delete your account from within the app, or email us if you have lost access.
        </Typography>
      </Container>
    </Box>
  );
}

export default SupportPage;
